import { findRequest } from '../../state/state';

const findRequestDatasets = ({ requests }, { category, code }) => {
  const item = findRequest({ requests }, { category, code });
  return { item, datasets: item.steps.datasets };
};

export default findRequestDatasets;
